<template>
	<!-- <div class="mainSlider"> -->
	<div class="mainSlider" :style="`background-image: url(${require('@/assets/img/home-banner-right.png')})`">
		<div class="container">
			<div class="row">
				<div class="col-12 col-md-8 col-lg-5">
					<div class="data">
						<h1>Soluciones para eventos</h1>
						<p>
							La plataforma más completa de venta de entradas y soluciones tecnológicas para eventos de
							música en vivo, creada para proporcionar experiencias inolvidables tanto para los asistentes
							como para los organizadores.
						</p>

						<h2>
							Si deseas conocer más acerca de como funciona nuestro servicio y comenzar a vender tu evento
							con nosotros no dudes en comunicarte.
						</h2>

						<a href="mailto:hola@cobraticket.uy" class="btn btn-primary mt-4">Escribinos ahora!</a>
					</div>
				</div>

				<!-- <div class="col-md-5">
					<img src="@/assets/img/home-banner-right.jpg" alt="" class="img-fluid" />
				</div> -->
			</div>
			<!-- <img src="@/assets/img/home-banner.jpg" alt="" class="img-fluid" /> -->
		</div>
	</div>
</template>

<script>
export default {
	name: "HomeSlider",

	data() {
		return {}
	}
}
</script>

<style scoped lang="scss">
.mainSlider {
	width: 100%;
	overflow: hidden;
	background-position: right top;
	background-repeat: no-repeat;
	background-size: contain;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 700px;

	h1 {
		font-size: 3rem;
		font-weight: 600;
		margin-bottom: 12px;
		line-height: 3rem;
	}
	h2 {
		font-size: 1.2rem;
		font-weight: 500;
		margin-bottom: 0;
		line-height: 1.6rem;
	}
	p {
		margin-bottom: 18px;
		font-size: 1.2rem;
		line-height: 1.6rem;
		color: #333;
	}

	.btn {
		padding: 9px 44px;
		border-radius: 26px;
		font-size: 1.2rem;
		font-weight: 500;
	}
}

@media (max-width: 991px) {
	.mainSlider {
		background-image: none !important;
	}
}
</style>
